<template>
    <base-container :isLoading="isLoading">
        <!-- <van-nav-bar title="公积金基本信息" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
        <div id="appdiv">
            <div class="container">
                <div class="appointmentinfo">
                    <header>
                        <!-- <van-nav-bar title="公积金明细查询" left-arrow @click-left="$router.go(-1)"></van-nav-bar> -->
                        <van-cell-group class="cellgrouptop">
                            <van-form>
                                <van-field v-model="username" name="身份证号" label="身份证号" placeholder="身份证号"
                                    :rules="[{ required: true, message: '请填写正确的身份证号',validator:validIdNo }]" />
                                <van-cell>
                                    <van-button type="primary" size="large" round class="artisan-btn"
                                        @click="queryInfo">查询
                                    </van-button>
                                </van-cell>
                            </van-form>
                        </van-cell-group>
                    </header>
                    <div class="flex_list" v-if="isSuccess">
                        <ul>
                            <li><span>职工姓名：</span> <span>{{userinfo.name}}</span></li>
                            <li><span>数据截止日期：</span><span>{{userinfo.lastDeposit}}</span></li>
                            <li><span>公积金账号：</span> <span>{{userinfo.accountNo}}</span></li>
                            <li><span>缴存单位：</span><span>{{userinfo.depositUnit}}</span></li>
                            <li v-if="1==2"><span>单位账号：</span><span>24313241</span></li>
                            <li><span>账户状态：</span><span>{{userinfo.accountState}}</span></li>
                            <li><span>缴存基数：</span> <span
                                    style="color:#F47447; font-weight: bold;">¥{{parseFloat(userinfo.depositBase).toFixed(2)}}</span>
                            </li>
                            <li><span>月缴额：</span> <span
                                    style="color:#F47447; font-weight: bold;">¥{{parseFloat(userinfo.monthlyDeposit).toFixed(2)}}</span>
                            </li>
                            <li><span>余额：</span> <span
                                    style="color:#F47447; font-weight: bold;">¥{{parseFloat(userinfo.balance).toFixed(2)}}</span>
                            </li>
                            <li v-if="1==2"><span>末次缴存月：</span> <span>2020-07</span></li>
                        </ul>
                    </div>
                    <div class="AppointmentDetail" v-if="isSuccess">
                        <section>
                            <div class="chosePay" style="text-align: center;">
                                <van-button type="primary" size="normal" round class="artisan-btn" @click="goToDetail">
                                    账户明细
                                </van-button>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>
    </base-container>
</template>
<script>
    import "@/assets/css/reset.css?=2";
    import "@/assets/css/comman.css?=2";
    import "@/assets/css/AppointmentInfo.css?=2";
    import "@/assets/css/AppointmentDetail.css?=2";
    import { Notify } from 'vant';
    import { QueryBasicInfo } from "@/api/housingfund";
    import { cardid } from "@/util/validate";
    export default {
        data() {
            return {
                isLoading: false,
                username: "",
                isSuccess: false,
                userinfo: {},
            }
        },
        created() {
        },
        methods: {
            queryInfo() {
                if (this.username == "") {
                    Notify({
                        type: 'danger',
                        message: "身份证号不能为空"
                    });
                }
                else {
                    if (cardid(this.username)[0]) {
                        Notify({
                            type: 'danger',
                            message: "请填写正确的身份证号"
                        });
                    }
                    else {
                        this.isLoading = true;
                        this.userinfo = {};
                        this.isSuccess = false;
                        QueryBasicInfo(this.username).then(res => {
                            if (res.data.value != null) {
                                this.userinfo = res.data.value;
                                this.isSuccess = true;
                            }
                            this.isLoading = false;
                        }).catch(() => {
                            this.isLoading = false;
                        });
                    }
                }
            },
            goToDetail() {
                this.toPage('providentquerydetail', { username: this.username })
            },
            toPage(name, params) {
                this.$router.push({ name, params });
            },
            validIdNo(val) {
                var res = cardid(val);
                return !res[0];
            },
        }
    }
</script>